import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { MatDialog } from '@angular/material/dialog';

import { map } from 'rxjs';

import { v4 as uuidv4 } from 'uuid';

import { Tables } from 'src/app/shared/entities/tables';

import { DynamicDocumentInfoService } from 'src/app/shared/services/dynamic-document-info.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { NotificationService } from 'src/app/services/notification.service';

import { DynamicDocumentInfo } from 'src/app/shared/entities/dynamic-document';

@Component({
    selector: 'app-export-fichier',
    templateUrl: './export-fichier.component.html',
    styleUrls: ['./export-fichier.component.css'],
})
export class ExportFichierComponent implements OnInit, OnDestroy {
    @Input() tab: Tables = new Tables();
    filters: any;
    types: any[] = [
        { label: 'CSV', value: 'csv' },
        { label: 'XLS', value: 'xls' },
        { label: 'XLSX', value: 'xlsx' },
    ];
    selectedType: string = 'csv';

    inProgress: boolean = false;
    progress: number = 0;

    fileId: string;

    private _dynamicDocumentInfo: DynamicDocumentInfo | null = null;

    constructor(
        private readonly _httpClient: HttpClient,
        private readonly _dialog: MatDialog,
        private readonly _dynamicDocumentInfoService: DynamicDocumentInfoService,
        private readonly _dynamicDocumentService: DynamicDocumentService,
        private readonly _notificationService: NotificationService
    ) { }

    public async ngOnInit(): Promise<void> {
        this._dynamicDocumentInfo = await this.retrieveDynamicDocumentInfo(this.tab.entite);
    }

    public ngOnDestroy(): void {
        this._notificationService.unsubscribeExportFileNotification();
    }

    public onExport(page: number): void {
        const currentPage = page ? page + 1 : 1;
        const pageSize = 2000;
        if (this._dynamicDocumentInfo !== null) {
            this.inProgress = true;
            if (this.tab.filresappliques) {
                this.filters = Object.values(this.tab.filresappliques).filter(
                    (filter: any) => filter !== null
                );
            }
            const exportFileRequest: any = {
                ids: this.tab.ids,
                filters:
                    this.tab.filresappliques != null
                        ? Object.values(this.tab.filresappliques).filter(
                            (filter: any) => filter !== null
                        )
                        : [],
                locales: this.tab.locales,
                isUseLabel: false,
            };

            // Override data export
            const overrideRequestData = {
                ...exportFileRequest,
                filters: exportFileRequest?.filters?.map((item: any) => {
                    const { fieldName, ...rest } = item;
                    const conditions = item?.conditions?.map((cd: any) => {
                        const { condition, type, id, value, valeur, ...restConditions } = cd;
                        return {
                            ...restConditions,
                            type: condition ?? type,
                            value: valeur?.value ? valeur.value : value,
                            id: id,
                        };
                    });
                    return { ...rest, fieldName: fieldName, conditions };
                }),
            };
            // Start Export
            if (
                this.tab.view !== undefined &&
                this.tab.view !== null &&
                this.tab.view.nom !== 'Default'
            ) {
                this.inProgress = true;
                this.fileId = uuidv4();

                this._notificationService.subscribeExportFileNotification(this.fileId, (notification: any) => {
                    if (notification.type === 'EXPORT_FILE_PROGRESS' && notification.fileId === this.fileId) {
                        this.progress = Math.round(notification.progress * 100) / 100; // Round to 2 decimal places
                    } else if (notification.type === 'EXPORT_FILE_REPORT' && notification.fileId === this.fileId) {
                        this.progress = 100;

                        const fileBytes = this.base64ToArrayBuffer(notification.report.fileContent);
                        const blob = new Blob([fileBytes], { type: 'application/octet-stream' });

                        setTimeout(() => {
                            this.handleExportSuccess(blob, this.tab.entite);
                            this.onClose();
                        }, 1000);
                    }
                });

                this._dynamicDocumentService.exportFileOnViewWithProgress(this.tab.entite, this.selectedType, this.tab.view.id, this.fileId, overrideRequestData).subscribe({
                    next: () => { },
                    error: () => { }
                });
            } else {
                this.inProgress = true;
                this.fileId = uuidv4();

                this._notificationService.subscribeExportFileNotification(this.fileId, (notification: any) => {
                    if (notification.type === 'EXPORT_FILE_PROGRESS' && notification.fileId === this.fileId) {
                        this.progress = Math.round(notification.progress * 100) / 100; // Round to 2 decimal places
                    } else if (notification.type === 'EXPORT_FILE_REPORT' && notification.fileId === this.fileId) {
                        this.progress = 100;

                        const fileBytes = this.base64ToArrayBuffer(notification.report.fileContent);
                        const blob = new Blob([fileBytes], { type: 'application/octet-stream' });

                        setTimeout(() => {
                            this.handleExportSuccess(blob, this.tab.entite);
                            this.onClose();
                        }, 1000);
                    }
                });

                this._dynamicDocumentService.exportFileWithProgress(this.tab.entite, this.selectedType, this.fileId, overrideRequestData).subscribe({
                    next: () => { },
                    error: () => { }
                });
            }
        } else {
            // Override data export
            const overrideFiltersRequestData = {
                ...Object.values(this.tab.filresappliques),
                filters: Object.values(this.tab.filresappliques)?.map((item: any) => {
                    const { fieldName, ...rest } = item;

                    const conditions = item?.conditions?.map((cd: any) => {
                        const { condition, type, id, value, valeur, ...restConditions } = cd;
                        return {
                            ...restConditions,
                            condition: condition ?? type,
                            valeur: valeur?.value ? valeur.value : value,
                            id: id,
                        };
                    });

                    return { ...rest, champ: fieldName, conditions };
                }),
            };

            this.inProgress = true;
            this.fileId = uuidv4();

            this._notificationService.subscribeExportFileNotification(this.fileId, (notification: any) => {
                if (notification.type === 'EXPORT_FILE_INFO' && notification.fileId === this.fileId) {
                    this.progress = 100;

                    const fileBytes = this.base64ToArrayBuffer(notification.info.content);
                    const blob = new Blob([fileBytes], { type: 'application/octet-stream' });

                    setTimeout(() => {
                        this.handleExportSuccess(blob, this.tab.entite);
                        this.onClose();
                    }, 1000);
                }
            });

            const url: string = this.tab.view !== undefined && this.tab.view !== null
                ? `/entite/export/view/${this.tab.view.id}/${this.selectedType}/files/${this.fileId}`
                : `/entite/export/${this.tab.entite}/${this.selectedType}/files/${this.fileId}`;

            this._httpClient.post<void>(url, {
                filtres: overrideFiltersRequestData?.filters,
                ids: this.tab.ids,
                locales: this.tab.locales,
                isUseLabel: false,
            }).subscribe({
                next: () => { },
                error: () => { }
            });
        }
    }

    handleExportSuccess(body: Blob, fileName: string) {
        const blob = new Blob(
            [body],
            this.selectedType === 'csv'
                ? { type: 'application/csv' }
                : { type: 'application/vnd.ms-excel' }
        );

        const objectUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = `export_${fileName}.${this.selectedType}`;
        link.click();

        URL.revokeObjectURL(objectUrl);
    }

    public onClose(): void {
        if (this.inProgress) {
            this._notificationService.unsubscribeExportFileNotification();
        }
        this._dialog.closeAll();
    }

    private base64ToArrayBuffer(base64: string): Uint8Array {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }

    private retrieveDynamicDocumentInfo(documentName: string): Promise<DynamicDocumentInfo | null> {
        return new Promise<DynamicDocumentInfo | null>(
            (resolve: (dynamicDocumentInfo: DynamicDocumentInfo | null) => void) => {
                this._dynamicDocumentInfoService.findByDocumentName(documentName).subscribe({
                    next: (dynamicDocumentInfo: DynamicDocumentInfo) => {
                        // Is dynamic document
                        resolve(dynamicDocumentInfo);
                    },
                    error: () => {
                        // Is static document
                        resolve(null);
                    },
                });
            }
        );
    }
}
